import React from 'react';
import { SearchContactConfirmationStep } from 'pages/components';

const ScreeningConfirmationStep = (props) => (
  <SearchContactConfirmationStep {...props} />
);

export default ScreeningConfirmationStep;
